import React from "react";
import { useImageLightboxTrigger } from "./useImageLightboxTrigger";

interface Props extends React.ImgHTMLAttributes<HTMLImageElement> {
	src: string;
	alt?: string;
}

const LightboxImage: React.FC<Props> = ({ src, alt, style, onClick, onKeyDown, ...rest }) => {
	const { onImageClick, onImageKeyDown } = useImageLightboxTrigger({ src, alt });

	return (
		<img
			{...rest}
			src={src}
			alt={alt ?? ""}
			tabIndex={0}
			role="button"
			style={{ ...(style as React.CSSProperties), cursor: "zoom-in" }}
			onClick={(event) => {
				onClick?.(event);
				if (!event.defaultPrevented) {
					onImageClick(event.currentTarget);
				}
			}}
			onKeyDown={(event) => {
				onKeyDown?.(event);
				if (!event.defaultPrevented) {
					onImageKeyDown(event);
				}
			}}
		/>
	);
};

export default LightboxImage;
